import s from './style.module.scss';
import GrtImage from '@/components/GrtImage';
import { Display } from '@/components/Display/Display';
import { useEffect, useState } from 'react';
import MyIcon from '@/components/MyIcon';
import { showPopup, hidePopup } from '@/utils/Page/modal';
import { handleCheckBusinessStatus, handleGetProjectListByCourseId } from '@/utils/Page/personalRecommend';
import { getCorrespondLabel } from '@/utils/global';
import ChoseProject from './ChoseProject';
const MobileResult = (props) => {
    const { resources = [] } = props;
    const [expand, setExpand] = useState(false);
    const [list, setList] = useState([]);

    const toggleExpand = () => {
        setExpand(!expand);
    };
    const handleList = () => {
        let data = [];
        if (!expand) {
            data = resources?.slice(0, 3);
        } else {
            data = resources;
        }

        setList(data);
    };
    useEffect(() => {
        handleList();
    }, [expand, resources]);
    const modalName = {
        chose: 'choseProject'
    };

    //关闭多项目选择
    const closeChose = () => {
        hidePopup(modalName.chose);
    };
    //点击立即学习
    const clickLearn = async (data) => {
        if (data.template_id === 0) {
            //校验业务状态
            let list = await handleGetProjectListByCourseId({ course_id: data?.business_id }, 'mobile');
            //多项目选择
            if (list.length > 0) {
                showPopup(<ChoseProject list={list} onClose={closeChose}></ChoseProject>, {}, modalName.chose);
            }
        } else {
            await handleCheckBusinessStatus({ template_id: data?.template_id, business_id: data?.business_id });
        }
    };
    //    关闭全部

    return (
        <>
            <div className={s['box-wrap']}>
                <>
                    <Display show={list.length > 0}>
                        <div className={s['list-wrap']}>
                            {list.map((ele, index) => {
                                return (
                                    <div key={index} className={s['list-item']}>
                                        <GrtImage src={ele?.image_url}></GrtImage>
                                        <div className={s['info-wrap']}>
                                            <div className={s['course-title']}>{ele.business_name}</div>
                                            <div className={s['list-action']}>
                                                <span className={s['type']}>
                                                    {ele.template_id === 0 ? '点播课' : getCorrespondLabel(ele.template_id)}
                                                </span>
                                                <span
                                                    data-type={'primary'}
                                                    onClick={() => {
                                                        clickLearn(ele);
                                                    }}
                                                    className={s['action-button']}
                                                >
                                                    立即学习
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <Display show={resources?.length >= 3}>
                            <div className={s['expand-box']} onClick={toggleExpand}>
                                <MyIcon style={{ fontSize: '20px' }} type={expand ? 'icon-a-Frame427319955' : 'icon-a-Frame4273199541'}></MyIcon>
                            </div>
                        </Display>
                    </Display>
                </>
            </div>
        </>
    );
};

export default MobileResult;
